import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { throttle } from 'throttle-debounce';
import { getValidParent } from './utils';

interface IElementInViewportProps {
  children: JSX.Element;
  parentBlockClass?: string;
  onChange?(isVisible: boolean): void;
  onVisibleFirst?(): void;
}

interface IElementInViewportState {
  isVisible: boolean;
  wasVisible: boolean;
}

export class ElementInViewport extends React.PureComponent<IElementInViewportProps, IElementInViewportState> {
  private parent: HTMLElement | Document | null = null;

  public state: IElementInViewportState = {
    isVisible: false,
    wasVisible: false,
  };

  public componentDidMount() {
    document.addEventListener('resize', this.handleResize);

    this.parent =
      // eslint-disable-next-line react/no-find-dom-node
      getValidParent(ReactDOM.findDOMNode(this) as HTMLElement, this.props.parentBlockClass || '') || document;
    this.parent.addEventListener('scroll', this.handleScroll);

    this.checkVisibility();
  }

  public componentWillUnmount() {
    this.handleResize.cancel();
    this.handleScroll.cancel();

    document.removeEventListener('resize', this.handleResize);
    // eslint-disable-next-line no-unused-expressions
    this.parent?.removeEventListener('scroll', this.handleScroll);
  }

  public componentDidUpdate(_prevProps: IElementInViewportProps, prevState: IElementInViewportState) {
    if (this.state.isVisible !== prevState.isVisible && this.props.onChange) {
      this.props.onChange(this.state.isVisible);
    }
  }

  public static getDerivedStateFromProps(props: IElementInViewportProps, state: IElementInViewportState) {
    if (!state.wasVisible && state.isVisible) {
      if (props.onVisibleFirst) {
        props.onVisibleFirst();
      }

      return { wasVisible: true };
    }

    return null;
  }

  public render() {
    return this.props.children;
  }

  private checkVisibility() {
    // eslint-disable-next-line react/no-find-dom-node
    const component = ReactDOM.findDOMNode(this) as HTMLElement;
    const { top, height } = component.getBoundingClientRect();
    const offset = Math.max(window.innerHeight - height, 0);

    const isVisible = top <= offset && top >= -height;

    if (isVisible !== this.state.isVisible) {
      this.setState({
        isVisible,
      });
    }
  }

  private handleResize = throttle(100, () => {
    this.checkVisibility();
  });

  private handleScroll = throttle(100, () => {
    this.checkVisibility();
  });
}
